import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { inject } from '@angular/core';
import {
  NETWORK_ERROR,
  NOT_FOUND_ERROR,
  PERMISSION_ERROR,
  SERVER_ERROR,
  SERVER_NOT_RESPONDING_ISSUE,
  BAD_GATEWAY_ERROR,
  SERVICE_UNAVAILABLE_ERROR,
  GATEWAY_TIMEOUT_ERROR,
} from '@core/constant/constant';
import { ToastService } from '@core/services/toast.service';
import { AuthService } from '@core/services/auth';

/**
 * Functional HTTP interceptor that handles errors globally.
 * Updated to the `HttpInterceptorFn` style matching `auth-interceptor`.
 */
export const errorHandlerInterceptor: HttpInterceptorFn = (req, next) => {
  const toast = inject(ToastService);
  const _auth = inject(AuthService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // No response (network error)
      if (error.status === 0) {
        toast.error(SERVER_NOT_RESPONDING_ISSUE || NETWORK_ERROR);
        return throwError(() => error);
      }

      const status = error.status;
      const message =
        (error.error &&
          (Array.isArray(error.error.message)
            ? error.error.message[0]
            : error.error.message)) ||
        'An unexpected error occurred.';

      switch (status) {
        case 400:
          const message404 = error?.error?.message || SERVER_ERROR;
          toast.error(message404);
          break;
        case 401:
          toast.error(PERMISSION_ERROR);
          _auth.logout();
          break;
        case 403:
          toast.error(PERMISSION_ERROR);
          _auth.logout();
          break;
        case 404:
          toast.error(NOT_FOUND_ERROR);
          break;
        case 500:
          const message = error?.error?.message || SERVER_ERROR;
          toast.error(message);
          break;
        case 502:
          toast.error(BAD_GATEWAY_ERROR);
          break;
        case 503:
          toast.error(SERVICE_UNAVAILABLE_ERROR);
          break;
        case 504:
          toast.error(GATEWAY_TIMEOUT_ERROR);
          break;
        default:
          toast.error(message);
          break;
      }

      return throwError(() => error);
    })
  );
};
